<template>
  <AppShell>
    <!-- Remove the header-actions slot entirely -->
    <NavCardList :cards="cards" list-class="homepage-list" />
  </AppShell>
</template>
<script setup>
import { onMounted } from 'vue';
import AppShell from '../components/AppShell.vue';
import NavCardList from '../components/NavCardList.vue';
import { getHomeCards } from '../composables/useNavCards.js';
import { homePageImages } from '../scripts/img_sound_imports.js';
import { setLanguage } from '../scripts/boot.js';

const cards = getHomeCards();

onMounted(() => {
  window.setLanguage = setLanguage;
});
</script>
